// An aroma family as someone else chose it: the drawing, the name and the family's colour band,
// like a FamilyChip but only saying, with no press and no focus stop. The colour is a second
// signal; the accessible themes draw the band as a bordered swatch.
import "./config";
import { Text, View, styled } from "tamagui";
import { AromaIcon, type AromaIconId } from "./AromaIcon";
import type { PaletteKey } from "./palette";

const Frame = styled(View, {
  name: "FamilyTag",
  flexDirection: "row",
  alignItems: "center",
  gap: "1",
  paddingLeft: "2",
  paddingRight: "2",
  paddingTop: 4,
  paddingBottom: 8,
  borderRadius: "3",
  borderWidth: "var(--borderW)",
  borderColor: "line",
  backgroundColor: "surface",
  overflow: "hidden",
  position: "relative",
});

const Label = styled(Text, {
  name: "FamilyTagLabel",
  fontFamily: "body",
  fontSize: "1",
  fontWeight: "700",
  color: "text",
});

export interface FamilyTagProps {
  name: string;
  icon: AromaIconId;
  colour: PaletteKey;
  testId?: string | undefined;
}

export function FamilyTag({ name, icon, colour, testId }: FamilyTagProps): React.JSX.Element {
  return (
    <Frame
      // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
      {...(testId === undefined ? {} : { "data-testid": testId })}
    >
      <AromaIcon id={icon} size={20} />
      <Label>{name}</Label>
      <View
        aria-hidden
        position="absolute"
        left={0}
        right={0}
        bottom={0}
        height={{ default: 4, a11yLight: 6, a11yDark: 6 }}
        borderTopWidth={{ default: 0, a11yLight: 2, a11yDark: 2 }}
        borderColor="text"
        backgroundColor={colour}
      />
    </Frame>
  );
}
